import { Box } from "@/components/ui/box"
import { HStack } from "@/components/ui/hstack"
import { Text } from "@/components/ui/text"
import { compactSkillChipStyle, skillChipStyle } from "@/constants/ChipStyles"
import { Colors } from "@/constants/Colors"
import { getSkill, getSkillDomainColor } from "@/data/prooftree"
import { Check, LucideIcon, Sparkles } from "lucide-react-native"
import { Platform } from "react-native"

export function SkillChip({
  skillId,
  selected = true,
  compact = false,
  icon: Icon,
}: {
  skillId: string
  selected?: boolean
  compact?: boolean
  icon?: LucideIcon
}) {
  const skill = getSkill(skillId)
  const color = getSkillDomainColor(skillId)
  const ChipIcon = Icon ?? (selected ? Check : Sparkles)

  return (
    <Box
      className="rounded-full border"
      style={{
        ...(compact ? compactSkillChipStyle : skillChipStyle),
        maxWidth: compact ? 180 : 240,
        backgroundColor: selected ? `${color}20` : Colors.dark.surfaceSecondary,
        borderColor: selected ? `${color}88` : "rgba(255,255,255,0.08)",
        shadowColor: selected ? color : "transparent",
        shadowOpacity: compact ? 0.12 : 0.2,
        shadowRadius: compact ? 6 : 10,
      }}
    >
      <HStack className="items-center gap-1.5">
        <ChipIcon color={selected ? color : Colors.dark.textSecondary} size={compact ? 13 : 14} />
        <Text
          numberOfLines={Platform.OS === "web" ? undefined : 1}
          className="text-xs font-bold"
          style={{
            color: selected ? color : Colors.dark.textSecondary,
            flexShrink: 1,
            lineHeight: 16,
          }}
        >
          {skill.title}
        </Text>
      </HStack>
    </Box>
  )
}
